<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2020.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2020-12-24                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <yega1-list-header :header="header" :items-length="itemsLength" :filtered-length="filteredLength"></yega1-list-header>
    <b-card no-body no-header>
      <b-card-header>
        <div class="d-flex justify-content-between align-items-baseline">
          <slot name="filter_actions">
            <yega1-button-new-item></yega1-button-new-item>
          </slot>
          <slot name="query_source">
            <yega1-query-interface :query-object-name="queryInterfaceObjectKey">
              <template v-slot:enums>
                <slot name="query_source_enums">
                </slot>
              </template>
            </yega1-query-interface>
          </slot>
          <slot name="filter_source">
            <yega1-filter-box></yega1-filter-box>
          </slot>
        </div>
      </b-card-header>
      <b-card-body :class="cardBodyClasses">
        <b-container fluid>
          <b-row>
            <b-col :sm="colSm" :md="colMd" :lg="colLg" :xl="colXl" v-for="item in filtered_sorted_items" :key="item.id" :class="colClasses">
              <slot name="card" v-bind:item="item">
                <b-card no-body>
                  <b-card-header>
                    <slot name="card_header" v-bind:item="item"></slot>
                  </b-card-header>
                  <b-card-title>
                    <slot name="card_title" v-bind:item="item"></slot>
                  </b-card-title>
                  <b-card-sub-title>
                    <slot name="card_sub_title" v-bind:item="item"></slot>
                  </b-card-sub-title>
                  <b-card-body>
                    <slot name="card_body" v-bind:item="item"></slot>
                  </b-card-body>
                  <b-card-text>
                    <slot name="card_text" v-bind:item="item"></slot>
                  </b-card-text>
                  <b-card-footer>
                    <slot name="card_footer" v-bind:item="item">
                      <yega1-button-edit-item :item="item"></yega1-button-edit-item>
                    </slot>
                  </b-card-footer>
                </b-card>

              </slot>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-card>
    <slot name="data_source">
      <yega1-axios-data-source ref="data_source"
                               :store-name="dataStoreName"
                               :store-query="dataStoreQuery"
                               :initial-load="dataInitialLoad"></yega1-axios-data-source>
    </slot>
    <slot name="dialog">
      <yega1-modal-form :store-name="dataStoreName"
                        :before-save="beforeSave"
                        :before-update="beforeUpdate"
                        :convert-to-attributes-string="dialogConvertToAttributesString"
                        :convert-to-attributes-json="dialogConvertToAttributesJson"
                        :convert-to-prices-text="dialogConvertToPricesText"
                        v-on:input-event="$emit('input-event',$event)"
                        v-on:form-hidden="$emit('form-hidden',$event)"
                        v-on:item-saved="$emit('item-saved',$event)"
                        v-on:item-updated="$emit('item-updated',$event)"
                        v-on:item-destroyed="$emit('item-destroyed',$event)"
                        v-on:item-loaded="$emit('item-loaded',$event)"
                        v-on:item-initialized="$emit('item-initialized',$event)">
        <template v-slot:header>
          <slot name="dialog_header"></slot>
        </template>
        <template v-slot:fields="data">
          <slot name="dialog_fields" v-bind:item="data.item" v-bind:isnew="data.isnew"></slot>
        </template>
      </yega1-modal-form>
    </slot>
    <slot name="import_dialog">
      <yega1-modal-upload-form ref="import_form"
                               :store-name="dataStoreName"
                               v-on:item-initialized="$emit('import-item-initialized',$event)"
                               v-on:item-saved="$emit('import-item-saved',$event)">
        <template v-slot:header>
          <slot name="import_dialog_header"></slot>
        </template>
        <template #fields="data">
          <yega1-form-group-file-input label="File"
                                       :item="data.item"
                                       field="document"
                                       accept=".xlsx"
                                       required>
          </yega1-form-group-file-input>
        </template>
      </yega1-modal-upload-form>

    </slot>
    <slot name="sort_source"></slot>
  </div>
</template>

<script>
import Yega1ButtonNewItem from "./yega1-button-new-item.vue";
import Yega1FilterBox from "./yega1-filter-box.vue";
import Yega1AxiosDataSource from "./yega1-axios-data-source.vue";
import Yega1ModalForm from "./yega1-modal-form.vue";
import Yega1ButtonEditItem from "./yega1-button-edit-item.vue";
import MixinUsesItemFilter from "./mixin-uses-item-filter";
import MixinUsesDialog from "./mixin-uses-dialog";
import MixinUsesNewButton from "./mixin-uses-new-button";
import MixinUsesEditButton from "./mixin-uses-edit-button";
import MixinUsesDataSource from "./mixin-uses-data-source";
import MixinUsesQueryInterface from "./mixin-uses-query-interface";
import MixinUsesImportDialog from "./mixin-uses-import-dialog";
import MixinUsesCloneButton from "./mixin-uses-clone-button";
import MixinUsesItemSorter from "./mixin-uses-item-sorter";
import Yega1ListHeader from "./yega1-list-header.vue";
import Yega1ModalUploadForm from "./yega1-modal-upload-form.vue";
import Yega1FormGroupFileInput from "./yega1-form-group-file-input.vue";
import Yega1QueryInterface from "./yega1-query-interface.vue";

export default {
  name: "yega1-cards-list",
  mixins:[
    MixinUsesItemFilter,
    MixinUsesDialog,
    MixinUsesNewButton,
    MixinUsesEditButton,
    MixinUsesDataSource,
    MixinUsesQueryInterface,
    MixinUsesImportDialog,
    MixinUsesCloneButton,
    MixinUsesItemSorter
  ],
  components: {
    Yega1QueryInterface,
    Yega1FormGroupFileInput,
    Yega1ModalUploadForm,
    Yega1ListHeader,
    Yega1ButtonEditItem,
    Yega1ModalForm,
    Yega1AxiosDataSource,
    Yega1FilterBox,
    Yega1ButtonNewItem
  },
  props:{
    header:{
      type:String,
      required:true
    },
    colSm:{
      type:String,
      default:'12'
    },
    colMd:{
      type:String,
      default:'6'
    },
    colLg:{
      type:String,
      default:'4'
    },
    colXl:{
      type:String,
      default:'3'
    },
    colClasses:{
      type:String,
      default:'mb-3'
    },
    cardBodyClasses:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped>

</style>
